export type ProtectedRouteState = 'login' | 'loading' | 'resetting' | 'error' | 'ready'

interface ProtectedRouteStateInput {
  hasToken: boolean
  hasUser: boolean
  isPending: boolean
  isError: boolean
  errorStatus?: number
}

export function resolveProtectedRouteState({
  hasToken,
  hasUser,
  isPending,
  isError,
  errorStatus,
}: ProtectedRouteStateInput): ProtectedRouteState {
  if (!hasToken) return 'login'
  if (isPending) return 'loading'
  if (isError && errorStatus === 401) return 'resetting'
  if (isError) return 'error'
  if (!hasUser) return 'login'
  return 'ready'
}
